import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from 'app/models/configuration/configuration';
import { SiteSettings } from 'app/pages/settings/settings-page/site-settings';
import { ConfigurationService } from 'app/services/configurations/configurations.service';


@Injectable({
  providedIn: 'root',
})
export class SynchronizationService {

  siteSettings = SiteSettings.getInstance();

  constructor(
    private router: Router, private serviceConfig: ConfigurationService

  ) { }

  setTimerToSync: any;
  intervalId: any;
  CNPJ: string;

  startSynchronize(CNPJaux: string) {
    this.router.navigate(['pages/dashboard']);
    // this._loadConfigServer().then((value) => {
    //   this.getSettings(CNPJaux).then(() => {
    //     Promise.all([
    //     ]).then(() => {
          
    //     }).catch(err => {
    //       console.error(err);
    //     });
    //   });
    // });
  }

  // _loadConfigServer() {
  //   return new Promise<boolean>((resolve) => {
  //       this.serviceConfig.getConfigurations().subscribe((value) => {
  //         this.siteSettings.setConfiguration(Configuration.fromJson(value.data));
  //         resolve(true);
  //       });
  //   });
  // }

  // getSettings(CNPJaux: string) {
  //   return new Promise<void>((resolve) => {
  //     let config = this.siteSettings.getConfiguration();
  //     this.CNPJ = config.CNPJ;

  //     if (!this.CNPJ || this.CNPJ === null || this.CNPJ.length === 0)
  //       this.CNPJ = CNPJaux;
  //     if (!localStorage.getItem('settings')) {
  //       localStorage.setItem('settings', JSON.stringify({ timerToSync: 300 }));
  //     }
  //     resolve();
  //   });
  // }
}
